<template>

	<div class="sidebar">
		<el-scrollbar>
			<el-menu class="sidebar-el-menu" :default-active="$route.name" :collapse="collapse" background-color="#324157"
			 text-color="#bfcbd9" active-text-color="#ffffff" unique-opened router>
				<template v-for="item in items">
					<template v-if="item.subs">
						<!-- 二级导航 -->
						<el-submenu :index="item.index" :key="item.index">
							<template slot="title">
								<i :class="item.icon"></i>
								<span slot="title">{{item.title }}</span>
							</template>
							<template v-for="subItem in item.subs">
								<el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
									<template slot="title">
										{{subItem.title}}
									</template>
									<el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index">{{ threeItem.title}}</el-menu-item>
								</el-submenu>
								<!-- 二级导航 单独 -->
								<el-menu-item :index="subItem.index" :key="subItem.index">{{ subItem.title}}</el-menu-item>
							</template>
						</el-submenu>
					</template>
					<template v-else>
						<el-menu-item :index="item.index" :key="item.index">
							<i :class="item.icon"></i>
							<span slot="title">{{ item.title }}</span>
						</el-menu-item>
					</template>
				</template>
			</el-menu>
		</el-scrollbar>
	</div>

</template>

<script>
	import bus from '../common/bus';
	//import { mapState } from 'vuex';

	export default {
		data() {
			return {
				collapse: false,
				items: []
			};
		},
		computed: {
			// ...mapState({
			// 	items: state => state.menu.navTree
			// }),
			onRoutes() {
				return this.$route.path.replace('/', '');
			}
		},
		created() {
			// 通过 Event Bus 进行组件间通信，来折叠侧边栏
			bus.$on('collapse', msg => {
				this.collapse = msg;
				bus.$emit('collapse-content', msg);
			});
		},
		mounted() {
			var ms_SideBar = JSON.parse(sessionStorage.getItem('ms_SideBar'));
			this.items = ms_SideBar;
			
			
		},
		methods: {
			createSidebar(bagArr) {
				// SideBar用
				var sideBarArr = [];
				var sideBarChildArr = [];
				var meta = null;
				bagArr.forEach((bag, index) => {
					if (bag.level !== 2 && bag.url !== '/message/messageList' && bag.url !== '/userCenter/userCenter' ) { // 排除用户中心和小铃铛特殊
						sideBarChildArr = [];
						var url = bag.url.split('/');
						// 从后台数据url中取得组件名
						var name = url[url.length - 1];
						if (typeof(bag.children) !== 'undefined' &&bag.children.length > 0) {
							//递归 去子层
							var result = this.createSidebar(bag.children);
							sideBarChildArr = result;
						}
						meta = {
							title: bag.name,
							icon: bag.icon,
							index: name
						};

						if(meta.index === '' || meta.index === null) { // 判断该siderbar是否存在路由
							meta.index = index.toString();
						}

						if(sideBarChildArr.length !== 0) {
							// 如果有子菜单则添加
							meta.subs = sideBarChildArr;
						}
						sideBarArr.push(meta);
					}
				});
				return sideBarArr;
			},
		}
	};
</script>

<style>
	.sidebar {
		display: block;
		position: absolute;
		left: 0;
		top: 70px;
		bottom: 0;
		overflow-y: scroll;
	}

	.sidebar::-webkit-scrollbar {
		width: 0;
	}

	.sidebar-el-menu:not(.el-menu--collapse) {
		width: 250px;
	}

	.sidebar>ul {
		height: 100%;
	}

	.el-menu-item.is-active {
		background-color: rgb(24, 144, 255) !important;
	}
	.sidebar .el-scrollbar {
		height: 100%;
	}

	.sidebar .el-scrollbar__wrap {
		overflow-x: hidden;
		overflow-y: scroll;
		width: 110%;
		height: 100%;
		background-color:rgb(50, 65, 87);
	}
</style>
